import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FunctionsService } from '../../___LOGIC/__common/functions.service';
import { GuiFlowService } from '../../___LOGIC/__gui/gui-flow.service';
import { ContactFormEntry } from '../../___LOGIC/__interfaces/ContactFormEntry';

const defaulFormObj: ContactFormEntry = ({} as any) as ContactFormEntry;

@Component({
  selector: 'app-first-contact-form',
  templateUrl: './first-contact-form.component.html',
  styleUrls: ['./first-contact-form.component.css']
})
export class FirstContactFormComponent implements OnInit {

  @Input() savedAnswersObj;
  @Input() mode;
  @Output() public dataOut = new EventEmitter();

  // Datepicker
  minDate: Date;
  maxDate: Date;
  //
  emailValid = false;
  managers = ['Sebas', 'Team'];
  showEmailInput = true;

  studies: string[] = ['Grado', 'Máster', 'Doctorado', 'Otro']; 
  hows: string[] = ['Amigo/Conocido', 'Instagram', 'Facebook', 'Página Web (Funnel form)','ClienteVoyJaleas','Google','TikTok', 'Otro']; 
  cities: string[] = ['Madrid', 'Barcelona', 'Valencia', 'Granada','Murcia','No definida','Otra']; 
  payments: string[] = ['Ahorros', 'Beca', 'Familiares', 'Ahorro y familiares','CONAPE y Ahorros','CONAPE','Ahorro y becas','Otra']; 
  careers: string[] = ['Administración de Empresas','Psicología', 'Ingeniería Industrial', 'Ingeniería en Sistemas','Derecho','Otra']; 
  apartmentTypes: string[] = ['Piso Privado','Estudio', 'Piso Compartido', 'Residencia Universitaria','Otra']; 
  
  constructor(private commonFunctions: FunctionsService,private guiFlow: GuiFlowService,) {
    const currentYear = new Date().getFullYear();
    this.minDate = new Date(currentYear - 70, 0, 1);
    this.maxDate = new Date(currentYear + 1, 11, 31);  
    this.mode? null : this.mode = 'create';
  }

  ngOnInit(): void {
  }

  saveNewLeadForm(operation){
    if(this.isFormValid()){
        this.processAnswersForm();
        // estas funciones las hará onboarding-page cuando este haga el emit
        // create clientDetails obj in Database /crear clietFollowUp in Database con status Videollamada, Añadir estas dos creaciones al historial
        operation === 'create'? this.commonFunctions.copyToClipboard(this.parseAnswersToEmailBody()) : null;
        this.dataOut.emit(this.savedAnswersObj);
        this.savedAnswersObj = {};
    }else{
      this.guiFlow.openSimpleSnackBar('Missing fields on form','error',null,'');
    }

  }

  parseAnswersToEmailBody(){
    let text;
    let present;
    let future;
    
    // Greet and Name
    this.savedAnswersObj.name? text = 'Hola ' + this.savedAnswersObj.name + ','+ '\n' :  text = 'Hola!'+ '\n';
    text += 'Antes que nada, agradecerte la confianza en nuestro proyecto y esperamos ser de ayuda para que consigas la meta que te has propuesto. Como te comentamos, te enviamos la minuta de la videollamada que hemos realizado hace unos días.';
    text += '\n'+ 'A modo de resumen, hemos entendido los siguientes detalles respecto a tu caso. Por favor, sentir completa libertad de comentar cualquier detalle adicional o bien corregirnos si es necesario. Estamos preparando una cotización que te enviaremos en cuanto nos confirmes esta información.';
    text += '\n';
    text += 'Saludos '+ '\n'+ '\n';
    text += 'Detalles de la videollamada '+ '\n'+ '\n';

    if(this.savedAnswersObj.goal){
      future = 'El objetivo planteado por ' + this.savedAnswersObj.name + ' es  '+this.savedAnswersObj.goal+'.'+'\n';
      text += future;
    }
    //No goal yet
    else{

    }

    if(this.savedAnswersObj.career){
      present = 'Actualmente trabaja como ' + this.savedAnswersObj.career +'.' + '\n';
      text += present;
    }
    if(this.savedAnswersObj.atEurope == 'yes'){
      present += 'Ya ha estado en Europa previamente en específico  ' + this.savedAnswersObj.atEurope+'.';
      text += present;
    }else{
      present += 'Esta será la primera vez que viaja por Europa.  ' + '\n';
      text += present;
    }

    if(this.savedAnswersObj.usVisa === 'yes'){
      present += 'Cuenta con la visa americana en caso de ser necesaria para el viaje de ida/regreso.' + this.savedAnswersObj.usVisa +'\n';
      text += present;
    }else{
      present += 'En este momento no tiene visa americana' + '\n';
      text += present;
    }

    if(this.savedAnswersObj.uePassport){
      present = text + 'Tiene familiares Europeos.' + this.savedAnswersObj.uePassport;
      text += present;
    }

    // Study search
    if(this.savedAnswersObj.studySearch){
      present = text + 'Ya ha comenzado con la búsqueda de Universidad/plan de estudios. ';
      text += present;
    }else{
      present = text + 'Por el momento no ha comenzado con la búsqueda de Universidad/plan de estudios. ';
      text += present;
      if(this.savedAnswersObj.studyChoice){
        present += 'El objetivo planteado sería '+this.savedAnswersObj.studyChoice+ '\n'+'.';
        text += present;
      }
    }

    // Study choice
    if(this.savedAnswersObj.studyType){
      future += 'Realizar un '+ this.savedAnswersObj.studyType;
      text += future;
      if(this.savedAnswersObj.university){
        future += ' en '+this.savedAnswersObj.university;
        text += future;
        if(this.savedAnswersObj.destination){
          future += 'ubicada en '+ this.savedAnswersObj.destination;
          text += future;
        }
      }else{
        future += ' en '+this.savedAnswersObj.destination;
        text += future;
      }
      
      if(this.savedAnswersObj.dateFrom){
        future += ' a comenzar en la fecha '+ this.savedAnswersObj.dateFrom;+'.';
        text += future;
      }
      
    }
    // No study choice yet
    else{
      future += 'El plan es encontrar un plan de estudios y una Universidad que se ajuste a los criterios deseados. ';
      text += future;
      if(this.savedAnswersObj.destination){
        future += 'La primera opción de ciudad es '+ this.savedAnswersObj.destination;
        text += future;
      }else{
        future += 'Por el momento no se ha elegido una ciudad en particular.';
        text += future;
      }
      // Date from
      if(this.savedAnswersObj.dateFrom){
        future += ' La idea sería comenzar aproximadamente el '+ this.savedAnswersObj.dateFrom;+'.';
        text += future;
      }else{
        future += 'La fecha de llegada a España se definirá posteriormente.'+ '\n';
        text += future;
      }
    }

    /* Se encuentra entre los planes pagar el Máster con la obtención de una Beca de estudios. También podría optar por la opción de un préstamo con CONAPE. */
    /* La idea sería conseguir una oferta laboral al terminar el Máster o bien mientras realiza los estudios. */
    text += 'Estos servicios te lo pasamos con detalle en la propuesta económica' + '\n';
    text += 'Cualquier detalle adicional o error nos comentas.' + '\n';
    text += 'Saludos' + '\n';

    this.savedAnswersObj.future = future;
    return text;
  }

  processAnswersForm(){
    if(this.savedAnswersObj){
      this.mode === 'create'? this.savedAnswersObj.firstContactDate = this.commonFunctions.getCurrentDate(null) : null;
      /* this.savedAnswersObj.dateFrom? this.savedAnswersObj.dateFrom = this.commonFunctions.getOnlyDate(this.savedAnswersObj.dateFrom) : null;
      this.savedAnswersObj.dateTo? this.savedAnswersObj.dateTo = this.commonFunctions.getOnlyDate(this.savedAnswersObj.dateTo) : null;
      this.savedAnswersObj.startLessons? this.savedAnswersObj.startLessons = this.commonFunctions.getOnlyDate(this.savedAnswersObj.startLessons) : null; */
    }else{
      console.log('NO SAVEDANSWERS OBJ');
    }
    
  }

  isFormValid(){
    return !this.commonFunctions.isQuestionUnanswered(this.savedAnswersObj.name) && 
    !this.commonFunctions.isQuestionUnanswered(this.savedAnswersObj.email) && 
    !this.commonFunctions.isQuestionUnanswered(this.savedAnswersObj.goal) && 
    !this.commonFunctions.isQuestionUnanswered(this.savedAnswersObj.destination);
  }

  getMainButtonCssClass(){
    let CssClass;
    this.isFormValid()? CssClass = 'main-action-btn': CssClass = 'main-action-btn btn-disabled'; 
    return CssClass;
  }

  isUpdateMode(){
    return this.mode === 'update';
  }

  validateEmail(data: any) {
    if (data.email.isValid) {
      /* this.newVoyJaleasContactFormEntry.email = data.email.value; */
      this.emailValid = true;
      this.savedAnswersObj.email = data.email.value;
    }
  }

}
